import React from "react";
import axios from 'axios';

import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { Link, useSearchParams } from "react-router-dom";

function TreeSubscriptionSuccessful() {
  const [searchParams] = useSearchParams();

  const user_id = searchParams.get("user_id");
  const verify_code = searchParams.get("verify_code");
  const family_code = searchParams.get("family_code");
  const plan_id = searchParams.get("plan_id");
  const datePaid = searchParams.get("datePaid");
  const expiryDate = searchParams.get("expiryDate");



  const {
    data: dataDetails,
    isLoading: isLoadingData,
    isError: isErrorData
  } = useQuery({
    queryKey: [
      "tree-subscription-successful",
      user_id,
      verify_code,
      family_code,
      plan_id,
      datePaid,
      expiryDate
    ],
  
    queryFn: () =>
      axios
        .get(`${API_URL}/tree-subscription-successfull-api`, {
          params: {
            user_id,
            family_code,
            verify_code,
            plan_id,
            datePaid,
            expiryDate
          },
          withCredentials: true
        })
        .then((response) => response.data),
  
    enabled:
      !!user_id &&
      !!verify_code &&
      !!family_code &&
      !!plan_id &&
      !!datePaid &&
      !!expiryDate,
  
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
  });

  const isMissingData =
    !user_id || !verify_code || !family_code || !plan_id || !datePaid || !expiryDate;

  return (
    <div className="main-wrapper d-flex align-items-center justify-content-center vh-100" style={{
      background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
      fontFamily: "'DM Sans', sans-serif",
      padding: '1rem'
    }}>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes popIn {
          0% { transform: scale(0); opacity: 0; }
          60% { transform: scale(1.1); opacity: 1; }
          100% { transform: scale(1); }
        }
      `}</style>

      <div className="card" style={{
        maxWidth: '460px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.15)',
        animation: 'fadeInUp 0.5s ease-out',
        textAlign: 'center'
      }}>

        {isMissingData ? (
          <>
            {/* Header — same gradient, different tone for the incomplete state */}
            <div style={{
              background: 'linear-gradient(135deg, #184A2C 0%, #0f3620 100%)',
              padding: '2rem 1.5rem 1.5rem'
            }}>
              <div style={{
                width: '76px',
                height: '76px',
                margin: '0 auto 1rem',
                background: '#fdece0',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="fa fa-exclamation-triangle" style={{ fontSize: '24px', color: '#ff6600' }}></i>
              </div>

              <p style={{
                color: 'rgba(255,255,255,0.6)',
                fontSize: '0.7rem',
                fontWeight: 600,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                margin: '0 0 0.4rem'
              }}>
                Subscription Status
              </p>

              <h3 style={{ color: '#ffffff', margin: 0, fontSize: '1.3rem', fontWeight: 600 }}>
                Confirmation Incomplete
              </h3>
            </div>

            <div style={{ padding: '1.75rem 1.75rem 1.5rem' }}>
              <p style={{ color: '#5c6b62', fontSize: '0.9rem', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
                We couldn't confirm all the details of your payment. If money was deducted,
                please contact support with your reference before retrying.
              </p>

              <div style={{
                background: '#f8fcf9',
                border: '1px solid #e5ede8',
                borderRadius: '12px',
                padding: '0.75rem',
                marginBottom: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}>
                <i className="fas fa-headset" style={{ color: '#75B437', fontSize: '0.9rem' }}></i>
                <p style={{ margin: 0, color: '#184A2C', fontSize: '0.8rem', fontWeight: 600 }}>
                  Contact support@oret.africa for help
                </p>
              </div>

             {/* <Link
                to="/"
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '0.75rem',
                  borderRadius: '40px',
                  background: '#75B437',
                  color: '#ffffff',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.background = '#184A2C'}
                onMouseLeave={(e) => e.target.style.background = '#75B437'}
              >
                Back to Login
              </Link>*/}
            </div>
          </>
        ) : (
          <>
            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #184A2C 0%, #0f3620 100%)',
              padding: '2rem 1.5rem 1.5rem'
            }}>
              <div style={{
                width: '76px',
                height: '76px',
                margin: '0 auto 1rem',
                background: 'rgba(255,255,255,0.15)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                animation: 'float 3s ease-in-out infinite'
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  background: '#75B437',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  animation: 'popIn 0.5s ease-out 0.15s both'
                }}>
                  <i className="fas fa-check" style={{ fontSize: '22px', color: '#ffffff' }}></i>
                </div>
              </div>

              <p style={{
                color: 'rgba(255,255,255,0.6)',
                fontSize: '0.7rem',
                fontWeight: 600,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                margin: '0 0 0.4rem'
              }}>
                Subscription Confirmed
              </p>

              <h3 style={{ color: '#ffffff', margin: 0, fontSize: '1.3rem', fontWeight: 600 }}>
                Payment Successful 🎉
              </h3>
            </div>

            {/* Body */}
            <div style={{ padding: '1.75rem 1.75rem 1.5rem' }}>
              <p style={{ color: '#5c6b62', fontSize: '0.9rem', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
                Thank you for subscribing! Your payment has been processed successfully.
                You can now log in to enjoy full access to your family tree.
              </p>

              {/* Subscription summary, built from the passed params */}
              <div style={{
                background: '#f8fcf9',
                border: '1px solid #e5ede8',
                borderRadius: '12px',
                padding: '0.9rem 1rem',
                marginBottom: '1.5rem',
                textAlign: 'left'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span style={{ fontSize: '0.75rem', color: '#8aa899' }}>Plan</span>
                  <span style={{ fontSize: '0.8rem', color: '#184A2C', fontWeight: 600 }}>{plan_id}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span style={{ fontSize: '0.75rem', color: '#8aa899' }}>Date Paid</span>
                  <span style={{ fontSize: '0.8rem', color: '#184A2C', fontWeight: 600 }}>{datePaid}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: '0.75rem', color: '#8aa899' }}>Expires</span>
                  <span style={{ fontSize: '0.8rem', color: '#184A2C', fontWeight: 600 }}>{expiryDate}</span>
                </div>
              </div>

              <div style={{
                background: '#f8fcf9',
                border: '1px solid #e5ede8',
                borderRadius: '12px',
                padding: '0.75rem',
                marginBottom: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}>
                <i className="fas fa-tree" style={{ color: '#75B437', fontSize: '0.9rem' }}></i>
                <p style={{ margin: 0, color: '#184A2C', fontSize: '0.8rem', fontWeight: 600 }}>
                  A confirmation receipt has been sent to you.
                </p>
              </div>

              {/*<Link
                to="/"
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '0.75rem',
                  borderRadius: '40px',
                  background: '#75B437',
                  color: '#ffffff',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.background = '#184A2C'}
                onMouseLeave={(e) => e.target.style.background = '#75B437'}
              >
                <i className="fas fa-sign-in-alt me-2"></i>
                Log In to Continue
              </Link>*/}
            </div>
          </>
        )}

        {/* Footer */}
        <div style={{
          borderTop: '1px solid #e5ede8',
          padding: '0.75rem',
          background: '#fafdfb'
        }}>
          <p style={{ fontSize: '0.7rem', color: '#8aa899', margin: 0 }}>
            <i className="fas fa-headset me-1"></i> Need help? Contact support@oret.africa
          </p>
        </div>

      </div>
    </div>
  );
}

export default TreeSubscriptionSuccessful;